module.exports = __webpack_public_path__ + "static/media/22ESCWA10.9f798e45.jpg";